module.exports = __webpack_public_path__ + "img/pic_tltw_bxssy_normal@2x.ed40b862.png";